export default __webpack_public_path__ + "static/media/blog.e0e899de.png";